import { BaseComponent } from '../../../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../../../components/Box';
import { Modal, ModalControls } from '../../../../../../components/Modal';
import { Button } from '../../../../../../components/Buttons';
import { Checkbox } from '../../../../../../components/Checkbox';
// import { VehicleCreateField } from './Fields';
import { VehicleCreateField } from './Fields';
import { selectConfig, selectUserId, selectWork, selectWorks } from '../../../../../Api/selectors';
import { fetchCompanies, updateAddress } from '../../../../../Companies/actions';
import { fetchHomeCompanyUsers } from '../../../../../Users/actions';
import {
  calculatePurchasePriceInclVatExclBPM,
  fetchVehicles,
  setNewVehicleValue,
  setNewVehicle,
  setVehicleProperty,
} from '../../../../../Vehicles/actions';
import { REQUEST_COMPANIES, REQUEST_COMPANY_WORKFLOWS } from '../../../../../Companies/constants';
import { REQUEST_HOME_COMPANY_USERS } from '../../../../../Users/constants';
import { selectNewVehicle, selectNewVehicleValue } from '../../../../../Vehicles/selectors';
import { selectCompany, selectCompanyWorkflows } from '../../../../../Companies/selectors';
import { selectAddressTypes } from '../../../../../Address/selectors';
import { getPropByName } from '../../../../../../utils/props';
import {
  CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM,
  REQUEST_VEHICLE_CREATE,
  VEHICLE_PURPOSE,
  VEHICLE_TAX_TYPE,
} from '../../../../../Vehicles/constants';
import { PURCHASING_PRICES_CRUD } from '../../../../../../components/Permission/constants';
import { Permission } from '../../../../../../components/Permission';
import env from '../../../../../../env';
import { WIENTJES_INSTALATION, AUTOHUISSALLAND_INSTALATION } from '../../../../../../containers/App/constants';
import { fetchWorkflows } from '../../../../../Workflows/actions';
import { REQUEST_WORKFLOWS, REQUEST_WORKFLOWS_FILTER } from '../../../../../Workflows/constants';
import { selectWorkflows } from '../../../../../Workflows/selectors';
import { List } from '../../../../../../components/List';
import { AppClientId } from '../../../../../Shared/constants';
import { Loader } from '../../../../../../components/Loader';
import { makeSelectLocale } from '../../../../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../../../../Companies/translate-countries';

const STATE = {
  address: null,
  homeUsers: null,
  saveStrategy: null,
  tasks: {},
};

const Container = styled.div`
  font-size: 14px;

  .req-field-message {
    color: red;
  }

  .title {
    font-size: 14px;
  }

  .calendar-block {
    width: 60%;
  }

  .address-section {
    width: 100%;
  }

  .address-block {
    margin-bottom: 24px;
    padding: 5px;
    border: 1px solid #ddd;
  }
  .cell:first-child {
    text-transform: capitalize;
  }

  .col {
    width: 100%;
    padding-right: 48px;
  }

  .info-card {
    width: 100%;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin: 6px;
    }
  }

  .req-field-message {
    color: red;
  }
`;

const Address = styled.div`
  border: ${props => (!!props.isActive ? '1px solid rgb(21, 172, 121)' : '1px solid grey')};
  border-radius: 6px;
  padding: 12px;
  width: calc(33% - 10px);
  height: 150px;
  margin: 6px 0;
  font-size: 12px;

  @media (max-width: 768px) {
    width: 100%;
  }

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }

  .req-field-message {
    color: red;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class AddVehicleModalBaseComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.fetch();
    this.props.fetchWorkflows();
    this.props.fetchUsers(res => {
      if (res.length) {
        this.setState({ homeUsers: res });
      }
    });

    this.setState({ creditorCompany: this.props.creditorCompany });

    if (this.props.tradeInVehicle) {
      this.props.setValue('marge', 'tax_type');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // this.props.values?.transport != 'pickup' && this.props.setValue('', 'location_address_id');
    if (this.props.values?.transport == 'develiver') {
      // this.setState({ address: null });
      this.props.setValue(this.props.creditorCompanyId, 'location_company_id');
      return this.props.setValue(this.homeAddress[0]?.id, 'location_address_id');
    }
    if (
      (!this.props.values?.location_address_id && this.props.values?.transport == ('pickup' || 'is_available')) ||
      this.props.values?.transport == 'anders'
    ) {
      this.props.setValue(this.props.creditorCompanyId, 'location_company_id');
      return this.props.setValue(this.homeAddress[0]?.id, 'location_address_id');
    }
  }

  reset() {
    this.setState({ ...STATE });
  }

  get locale() {
    return this.props.locale;
  }

  get addressTypeId() {
    return this.props.addressTypes?.filter(t => t.name == 'delivery')[0].id;
  }

  get deliveryAddresses() {
    return this.state.creditorCompany?.addresses;
    // return this.state.creditorCompany?.addresses.filter(a => a.typeId == this.addressTypeId);
  }

  get propertyNames() {
    return Object.keys(this.props.values);
  }

  get homeAddress() {
    const homeTypeId = this.props.addressTypes?.filter(t => t.name == 'home')[0].id;

    return this.state.creditorCompany?.addresses.filter(a => a.typeId == homeTypeId);
  }

  get companySource() {
    return getPropByName(this.state.creditorCompany, 'company_from_eu');
  }

  get acceptCopyBody() {
    return this.props.acceptCopy();
  }

  get workflow() {
    if (!this.props.selectedWorkflowId || !this.props.availableWorkflows) return null;
    return this.props.availableWorkflows.find(w => w.id === this.props.selectedWorkflowId);
  }

  get attachedWorkflows() {
    return this.props.attachedWorkflows ?? [];
  }

  get vatPricesFieldsToBeReset() {
    let fields = [
      'financial_purchase_price_excl_vat_excl_bpm',
      'financial_purchase_price_incl_vat_excl_bpm',
      // 'financial_purchase_price_marge_bpm',
      'financial_purchase_price_incl_vat_bpm',
    ];

    switch (env.clientId) {
      case AppClientId.INDEWAL:
        break;
      case AppClientId.HARRY_NIJBOER:
        break;
      case AppClientId.HOOIKAMMER:
        break;
      case AppClientId.IDW_GMBH:
        break;
      case AppClientId.AUTOWIENTJES:
        fields = ['financial_purchase_price_marge_excl_bpm', 'financial_purchase_price_marge_bpm'];
        break;
      case AppClientId.AUTOHUISSALLAND:
        fields = ['financial_purchase_price_marge_excl_bpm', 'financial_purchase_price_marge_bpm'];
        break;
    }

    return fields;
  }

  get margePricesFieldsToBeReset() {
    let fields = [
      'financial_purchase_price_marge_excl_bpm',
      'financial_purchase_price_marge_bpm',
      'financial_purchase_price_incl_vat_bpm',
    ];

    switch (env.clientId) {
      case AppClientId.INDEWAL:
        break;
      case AppClientId.HARRY_NIJBOER:
        break;
      case AppClientId.HOOIKAMMER:
        break;
      case AppClientId.IDW_GMBH:
        break;
      case AppClientId.AUTOWIENTJES:
        fields = ['financial_purchase_price_marge_excl_bpm', 'financial_purchase_price_marge_bpm'];
        break;
      case AppClientId.AUTOHUISSALLAND:
        fields = ['financial_purchase_price_marge_excl_bpm', 'financial_purchase_price_marge_bpm'];
        break;
    }

    return fields;
  }

  setDefaultFields(types) {
    if (env.clientId === AppClientId.INDEWAL || !Object.values(AppClientId).includes(env.clientId)) {
      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          // 'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          'financial_purchase_price_incl_vat_excl_bpm',
          // 'financial_purchase_price_marge_bpm',
          'financial_purchase_price_incl_vat_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_excl_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          // 'financial_purchase_price_excl_vat_excl_bpm',
          // 'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_marge_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_incl_vat_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_marge_bpm',
          // 'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
      }

      return types;
    }

    if (env.clientId === AppClientId.HARRY_NIJBOER) {
      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          // 'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          'financial_purchase_price_incl_vat_excl_bpm',
          // 'financial_purchase_price_marge_bpm',
          'financial_purchase_price_incl_vat_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_excl_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          // 'financial_purchase_price_excl_vat_excl_bpm',
          // 'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_marge_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_incl_vat_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_marge_bpm',
          // 'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
      }

      return types;
    }

    if (env.clientId === AppClientId.HOOIKAMMER) {
      if (
        this.props.values?.import === '0' &&
        // Keep the line below for hooikammer installation
        this.props.values?.vehicle_purpose &&
        this.props.values?.vehicle_purpose !== VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          // 'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          'financial_purchase_price_incl_vat_excl_bpm',
          // 'financial_purchase_price_marge_bpm',
          'financial_purchase_price_incl_vat_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_excl_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        // Keep the line below for hooikammer installation
        this.props.values?.vehicle_purpose &&
        this.props.values?.vehicle_purpose !== VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_marge_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_incl_vat_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_marge_bpm',
          // 'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
      }

      return types;
    }

    if (env.clientId === AppClientId.IDW_GMBH) {
      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          // 'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          'financial_purchase_price_incl_vat_excl_bpm',
          // 'financial_purchase_price_marge_bpm',
          'financial_purchase_price_incl_vat_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_excl_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          // 'financial_purchase_price_excl_vat_excl_bpm',
          // 'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_marge_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_incl_vat_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_marge_bpm',
          // 'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
      }

      return types;
    }

    if (env.clientId === AppClientId.AUTOWIENTJES || env.clientId === AppClientId.AUTOHUISSALLAND) {
      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          // 'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
      ) {
        [
          'financial_purchase_price_incl_vat_excl_bpm',
          // 'financial_purchase_price_marge_bpm',
          'financial_purchase_price_incl_vat_bpm',
          'financial_purchase_price_excl_vat_excl_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_marge_excl_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          // 'financial_purchase_price_excl_vat_excl_bpm',
          // 'financial_purchase_price_incl_vat_excl_bpm',
          'financial_purchase_price_marge_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_incl_vat_bpm']);
      }

      if (
        this.props.values?.import === '0' &&
        this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
        this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
      ) {
        [
          'financial_purchase_price_marge_excl_bpm',
          'financial_purchase_price_marge_bpm',
          // 'financial_purchase_price_incl_vat_bpm',
        ].map(type => this.props.setValue('', type));
        return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
      }

      return types;
    }

    return types;
  }

  getColumnTypes() {
    let types = [];
    switch (env.clientId) {
      case AppClientId.INDEWAL:
        types = ['vin', 'transport', 'vehicle_purpose', 'extra_cost_transport_kosten_inkomend'];
        break;
      case AppClientId.HARRY_NIJBOER:
        types = ['vin', 'vehicle_purpose', 'extra_cost_transport_kosten_inkomend'];
        break;
      case AppClientId.HOOIKAMMER:
        types = [
          'vin',
          //only show following for hooikammer
          'articlecode',
          'vehicle_purpose',
          //only show following for hooikammer
          'HOOI_standard_treatment',
          'HOOI_stalling',
          'HOOI_task_extreme_cleaning',
          'HOOI_task_desticker',
          'HOOI_task_polish_exterior',
          'HOOI_no_keys',
          'HOOI_rolbaar',
          'HOOI_rijdbaar',
          'HOOI_niet_rolbaar',
          'HOOI_rijdbaar_slechte_accu',
        ];
        break;
      case AppClientId.IDW_GMBH:
        types = ['vin', 'vehicle_purpose', 'extra_cost_transport_kosten_inkomend'];
        break;
      case AppClientId.AUTOWIENTJES:
        types = ['vin', 'vehicle_purpose', 'rest_bpm', 'extra_cost_transport_kosten_inkomend'];
        break;
      case AppClientId.AUTOHUISSALLAND:
        types = ['vin', 'vehicle_purpose', 'rest_bpm', 'is_owner', 'make_tasks'];
        break;
    }

    if (this.props.values?.make_tasks == '1') {
      types = types.concat(
        ...[
          'SALLAND_poetsen_compleet',
          'SALLAND_poetsen_binnenkant',
          'SALLAND_poetsen_buitenkant',
          'SALLAND_velgen_wisselen',
          'SALLAND_ozon_behandeling',
          'SALLAND_glascoating',
        ],
      );
    }

    if (this.props.values?.is_owner == '1') {
      types = types.concat(...['extra_cost_transport_kosten_inkomend']);
    }

    if (!this.props.values?.tax_type) {
      [
        'financial_purchase_price_excl_vat_excl_bpm',
        'financial_purchase_price_incl_vat_excl_bpm',
        'financial_purchase_price_marge_bpm',
        'financial_purchase_price_marge_excl_bpm',
        'financial_purchase_price_incl_vat_bpm',
      ].map(type => this.props.setValue('', type));
    }

    if (!this.props.values?.vehicle_purpose) {
      ['financial_purchase_price_marge_bpm', 'financial_purchase_price_incl_vat_bpm'].map(type =>
        this.props.setValue('', type),
      );
    }

    if (this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge && this.props.values?.import === '1') {
      this.vatPricesFieldsToBeReset.map(type => this.props.setValue('', type));
      return types.concat(...['financial_purchase_price_marge_excl_bpm']);
    }

    if (this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW && this.props.values?.import === '1') {
      this.margePricesFieldsToBeReset.map(type => this.props.setValue('', type));
      return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
    }

    if (
      this.props.values?.import === '0' &&
      this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
    ) {
      [
        // 'financial_purchase_price_marge_excl_bpm',
        'financial_purchase_price_excl_vat_excl_bpm',
        'financial_purchase_price_incl_vat_excl_bpm',
        'financial_purchase_price_incl_vat_bpm',
      ].map(type => this.props.setValue('', type));
      return types.concat(...['financial_purchase_price_marge_bpm']);
    }

    if (
      this.props.values?.import === '0' &&
      this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.Marge
    ) {
      [
        'financial_purchase_price_incl_vat_excl_bpm',
        // 'financial_purchase_price_marge_bpm',
        'financial_purchase_price_incl_vat_bpm',
        'financial_purchase_price_excl_vat_excl_bpm',
      ].map(type => this.props.setValue('', type));
      return types.concat(...['financial_purchase_price_marge_excl_bpm']);
    }

    if (
      this.props.values?.import === '0' &&
      this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Passenger &&
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
    ) {
      [
        'financial_purchase_price_marge_excl_bpm',
        // 'financial_purchase_price_excl_vat_excl_bpm',
        // 'financial_purchase_price_incl_vat_excl_bpm',
        'financial_purchase_price_marge_bpm',
      ].map(type => this.props.setValue('', type));
      return types.concat(...['financial_purchase_price_incl_vat_bpm']);
    }

    if (
      this.props.values?.import === '0' &&
      this.props.values?.vehicle_purpose === VEHICLE_PURPOSE.Commercial &&
      this.props.values?.tax_type === VEHICLE_TAX_TYPE.BTW
    ) {
      [
        'financial_purchase_price_marge_excl_bpm',
        'financial_purchase_price_marge_bpm',
        // 'financial_purchase_price_incl_vat_bpm',
      ].map(type => this.props.setValue('', type));
      return types.concat(...['financial_purchase_price_excl_vat_excl_bpm', 'financial_purchase_price_incl_vat_excl_bpm']);
    }

    return types;
  }

  handleSetDeliveryAddress = a => {
    this.setState({ address: a });
    this.props.setValue(this.state.creditorCompany?.id, 'location_company_id');
    return this.props.setValue(a.id, 'location_address_id');
  };

  save() {
    this.setState({ saveStrategy: 4 });
    this.props.onSave();
  }

  quickSave = () => {
    this.setState({ saveStrategy: 3 });
    this.props.onSave(() => {
      alert(`${this.lblStr('alert.success.vehicle_added')}`);
      this.props.fetchVehicles();
    }, 'quickSave');
  };

  addAndCopy = () => {
    this.setState({ saveStrategy: 2 });
    this.props.onSave(() => {
      this.props.setValue('', 'vin');
      this.props.setValue('', 'regplate');
      this.props.setValue('', 'rest_bpm');
      this.props.setValue('', 'outgoing_rest_bpm');
      alert(`${this.lblStr('alert.success.vehicle_added')}`);
    });
  };

  addAndNew = () => {
    this.setState({ saveStrategy: 1 });
    this.props.onSave(() => {
      this.props.back();
    }, 'addAndNew');
  };

  onSelectWorkflow(workflowId) {
    const workflow = this.attachedWorkflows.find(w => w.id === workflowId);
    const tasks = workflow?.tasks ?? [];
    console.log('!!!!!!!!!!!!! tasks !!!!!!!!!!!!!!!!!!!', workflow?.tasks);
    const tasksState = tasks.reduce((prev, curr) => {
      prev[curr] = 1;
      return prev;
    }, {});
    this.setState({ tasks: tasksState });
  }

  renderTaskCheckbox = t => (
    <HBox vCenter left style={{ gap: 10 }}>
      <Checkbox
        checked={!!this.state.tasks[t] ? 1 : 0}
        onChange={() => {
          this.setState(
            prev => {
              return { tasks: { ...prev.tasks, [t]: prev.tasks[t] ? 0 : 1 } };
            },
            () => this.props.setValue(`${this.state.tasks[t]}`, t),
          );
        }}
      />
      <span>{this.lbl(`workflows.details.tasks.${t}`)}</span>
    </HBox>
  );

  get mainModalFields() {
    let fields = ['regplate', 'import', 'ex_rental', 'brand_name', 'model_name', 'buying_contact', 'tax_type', 'transport'];

    switch (env.clientId) {
      case AppClientId.INDEWAL:
        break;
      case AppClientId.HARRY_NIJBOER:
        break;
      case AppClientId.HOOIKAMMER:
        fields = [
          'regplate',
          'brand_name',
          'model_name',
          'buying_contact',
          'tax_type',
          'transport',
          // 'ex_rental',
          'workflowId',
        ];
        break;
      case AppClientId.IDW_GMBH:
        break;
      case AppClientId.AUTOWIENTJES:
        fields = ['regplate', 'import', 'brand_name', 'model_name', 'buying_contact', 'tax_type'];
        break;
      case AppClientId.AUTOHUISSALLAND:
        fields = ['regplate', 'import', 'brand_name', 'model_name', 'mileage', 'buying_contact', 'tax_type'];
        break;
    }

    return fields;
  }

  isDeliverySectionVisible() {
    return ![AppClientId.AUTOWIENTJES, AppClientId.AUTOHUISSALLAND].includes(env.clientId);
  }

  applyDisabled() {
    return this.props.work || !this.props.values?.creditor_company;
  }

  render() {
    let disableMandatory = this.props.work;
    if (env.clientId === AppClientId.AUTOHUISSALLAND) {
      disableMandatory = !this.props.values?.is_owner || this.props.work;
    }
    return (
      <Container>
        <Modal mediumWide onClose={this.props.reset} title={this.lblStr('vehicle.order.add_incoming_order')}>
          <VBox className="cols">
            <div className="info-card">
              <HBox flip={window.innerWidth < 768}>
                <VBox className="col">
                  {this.state.creditorCompany &&
                    this.mainModalFields.map(type => (
                      <Permission permission={type === 'tax_type' ? PURCHASING_PRICES_CRUD : null} key={type}>
                        <div>
                          <VehicleCreateField
                            key={type}
                            type={type}
                            vehicle_id={this.props.vehicle_id}
                            loggedInUserId={this.props.loggedInUserId}
                            homeUsers={this.state.homeUsers && this.state.homeUsers}
                            creditorCompanyId={this.props.values?.creditor_company}
                            companySource={this.companySource}
                            companyType={this.state?.creditorCompany?.company_type}
                            availableWorkflows={this.attachedWorkflows}
                            onSelectWorkflow={this.onSelectWorkflow.bind(this)}
                          />
                        </div>
                      </Permission>
                    ))}
                  {this.workflow && <List>{this.workflow.tasks?.map(t => this.renderTaskCheckbox(t))}</List>}
                </VBox>

                <VBox className="col">
                  {this.state.creditorCompany &&
                    this.getColumnTypes().map(type => {
                      if (type === 'extra_cost_transport_kosten_inkomend') {
                        return (
                          this.props.config?.appClientId == WIENTJES_INSTALATION.APP_CLIENT_ID ||
                          (this.props.config?.appClientId == AUTOHUISSALLAND_INSTALATION.APP_CLIENT_ID && (
                            <VehicleCreateField
                              key={type}
                              value="80"
                              type={type}
                              vehicle_id={this.props.vehicle_id}
                              companySource={this.companySource}
                              companyType={this.state?.creditorCompany?.company_type}
                            />
                          ))
                        );
                      }
                      return (
                        <Permission permission={type === VEHICLE_PURPOSE.PropertyName ? PURCHASING_PRICES_CRUD : null}>
                          {type === 'is_owner' && <div className="req-field-message">{'Eigenaar is verplicht *'}</div>}
                          <VehicleCreateField
                            key={type}
                            type={type}
                            vehicle_id={this.props.vehicle_id}
                            companySource={this.companySource}
                            companyType={this.state?.creditorCompany?.company_type}
                          />
                        </Permission>
                      );
                    })}
                </VBox>
              </HBox>
            </div>
          </VBox>
          <VBox left>
            {this.isDeliverySectionVisible() && (
              <>
                <div className="address-section">
                  <h2 className="title">{this.lbl('vehicle.order.delivery_location')}</h2>
                  <HBox left flexWrap flip={window.innerWidth < 768} style={{ gap: 10 }} className={'address-block'}>
                    {(this.props.values?.transport === 'is_available' || this.props.values?.transport === 'pickup') &&
                      this.deliveryAddresses &&
                      this.deliveryAddresses?.map(address => (
                        <Address
                          key={`${address?.id}`}
                          onClick={() => address.country && this.handleSetDeliveryAddress(address)}
                          isActive={this.state.address?.id === address?.id}
                        >
                          <VBox left>
                            <HBox vCenter>
                              <h3 className="name">{this.lbl(`address.type.${address?.type?.name || 'other'}`)}</h3>
                              <Checkbox disabled={!address.country} checked={this.state.address?.id === address?.id} />
                            </HBox>
                            <VBox className="address" left>
                              <div>{address?.addressLine1}</div>
                              <div>
                                {address?.postcode} {address?.city}
                              </div>
                              <div>{translateCountry(address.country?.name, this.locale)}</div>
                              {!address.country && <div className="req-field-message">{'Country is required *'}</div>}
                            </VBox>
                          </VBox>
                        </Address>
                      ))}
                  </HBox>
                </div>

                <div className="calendar-block">
                  <VehicleCreateField key={'date_expected'} type={'date_expected'} />
                </div>
              </>
            )}

            {this.props.workVehicleCreate ? (
              <Modal onClose={() => {}}>
                <HBox center>
                  <strong>{this.lbl('vehicle.create.loading')}</strong>
                </HBox>
                <HBox center>
                  <Loader />
                </HBox>
              </Modal>
            ) : null}
          </VBox>
          <ModalControls>
            <Button primary type="submit" disabled={this.applyDisabled()} small onClick={this.save.bind(this)}>
              {this.lblStr('vehicle.btn.save.continue')}
            </Button>
          </ModalControls>
        </Modal>
      </Container>
    );
  }
}

AddVehicleModalBaseComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  address: PropTypes.object,
  vehicle: PropTypes.object,
  reset: PropTypes.func,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      REQUEST_COMPANIES,
      REQUEST_HOME_COMPANY_USERS,
      CALCULATE_PURCHASE_PRICES_INCL_VAT_EXCL_BPM,
      REQUEST_VEHICLE_CREATE,
      REQUEST_WORKFLOWS_FILTER,
      REQUEST_WORKFLOWS,
      REQUEST_COMPANY_WORKFLOWS,
    ]),
    workVehicleCreate: selectWork(REQUEST_VEHICLE_CREATE),
    loggedInUserId: selectUserId(),
    values: selectNewVehicle(),
    creditorCompany: selectCompany(ownProps.creditorCompanyId),
    addressTypes: selectAddressTypes(),
    config: selectConfig(),
    availableWorkflows: selectWorkflows(),
    selectedWorkflowId: selectNewVehicleValue('workflowId'),
    attachedWorkflows: selectCompanyWorkflows(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchCompanies());
    },
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewVehicleValue(name, value));
    },
    resetValues(values, name = null) {
      values.map(type => dispatch(setNewVehicleValue(type, '')));
    },
    setVehicleProperty(vehicleId, propertyName, propertyValue) {
      dispatch(setVehicleProperty(vehicleId, propertyName, propertyValue));
    },
    fetchUsers(callback) {
      dispatch(fetchHomeCompanyUsers(callback));
    },
    calculatePurchasePrice(enteredAmounts, callback) {
      dispatch(calculatePurchasePriceInclVatExclBPM(enteredAmounts, callback));
    },
    updateAddress(companyId, addressId, addressDto, callback) {
      dispatch(updateAddress(companyId, addressId, addressDto, callback));
    },
    fetchVehicles() {
      dispatch(fetchVehicles());
    },
    setNewVehicle() {
      dispatch(setNewVehicle());
    },
    fetchWorkflows() {
      dispatch(fetchWorkflows(0, 1000));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const AddVehicleModalBase = compose(withConnect, withRouter, injectIntl)(AddVehicleModalBaseComp);
